<template>
    <div class="modal-content paymentMethod-modal">
        <div class="modal-header border-blow">
            <h3 class="modal-title" id="exampleModalLabel">{{ $t('add-a-new-account', 'Add a new account') }}</h3>
            <button type="button" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="accountList-wrap">
                <div class="accountList-item" v-for="(item, index) in paymentMethodList" :key="index" @click="selectItem(item)" data-bs-dismiss="modal">
                    <div class="accountList-bank">
                        <div class="accountList-icon">
                            <img :src="item?.icon ? item?.icon  : require('@/assets/images/bank-img.webp')" alt="bank icon">
                        </div>
                        <div class="accountList-title">{{ item.method_name }}</div>
                    </div>
                    <div class="new-arrow">
                        <img loading="lazy" src="@/assets/images/angle_right.svg" alt="arrow right">
                    </div>
                </div>
            </div>
            <!-- <div class="header-but info-footer">
                <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal">{{ $t('cancel', 'Cancel') }}</button>
                <a class="thm-but save-notification">{{ $t('save-changes', 'Save changes') }}</a>
            </div> -->
        </div>
    </div>
</template>

<script>

export default {
    name: 'PaymentMethod',
    inject:['walletConfig'],
    props:['paymentMethodList'],
    data() {
		return {
			loading: false,
            onlyBankStatus: false
		}
	},
    methods: {
        selectItem(item) {
            const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
            this.$router.push({ name: 'add-account' });
            this.$store.dispatch('setSelectedPayementAcc', item);
		},
    }
}
</script>